import React from "react";
import {
  containerTooltipIconStyle,
  tooltipStyle,
  wrapperInfoIconStyle,
} from "./tooltip.css";
import { Text } from "@vagastec/ensemble-core";
import { InfoIcon } from "../icons/info-icon";

export function Tooltip({ active, setActive, text }) {
  let timeout;

  const showTip = () => {
    timeout = setTimeout(() => {
      setActive(true);
    }, 400);
  };

  const hideTip = () => {
    clearInterval(timeout);
    setActive(false);
  };
  return (
    <div className={containerTooltipIconStyle}>
      <div
        className={wrapperInfoIconStyle}
        onMouseEnter={showTip}
        onMouseLeave={hideTip}
      >
        <InfoIcon width={18} height={18} />
      </div>
      {active ? (
        <div className={tooltipStyle} data-testid="idActive">
          <Text>{text}</Text>
        </div>
      ) : null}
    </div>
  );
}
